import React, { Component } from 'react';
import { connect } from 'react-redux';

import ReadonlyCodeEditor from './ReadonlyCodeEditor';
import CodeEditor from './CodeEditor';
import FakeBrowser from './FakeBrowser';

import '../assessment/quiz.css';
import { withTranslation } from 'react-i18next';

import ReactMarkdown from 'react-markdown';


class RenderCodeEditor extends Component {

    constructor(props){
        super(props)
        this.state = {
            view: 'code'
        } //question (question+code) / rendered_view / both
    }

    render(){
        //const { t } = this.props;
        /*console.log('AAAAAAAAAAAAAAAAA')
                  console.log(this.props)*/


        const questionViews = {
            code: <CodeView {...this.props}/>,
            rendered_view: <CodeRenderView {...this.props}/>,
            both: <BothView {...this.props}/>
        }

        let questionComponent = questionViews[this.state.view]


        const classActiveButton = "btn btn-sm btn-primary active";
        const classInactiveButton = "btn btn-sm btn-secondary";
        // TODO: don't show double view on mobile - not worth it anyway, let users switch
        return <div>
            <center>
                <div className="btn-group btn-group-toggle" data-toggle="buttons" style={{'margin-bottom': '3px'}}>
                  <label className={this.state.view === 'question'? classActiveButton : classInactiveButton} onClick={() => this.setState({view: 'code'})}>
                    <img
                        src="/images/lesson-icons/html/code-file.png"
                        src3="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTeNso4NRZVC1JNli6jHXF_KoP8v5xh-oTJLDXM552McJM-Pvkd&usqp=CAU"
                        src2="https://cdn0.iconfinder.com/data/icons/seo-smart-pack/128/grey_new_seo-37-512.png"
                        style={{height: '25px'}}
                        alt="code"/>
                  </label>
                  &nbsp;
                  <label className={this.state.view === 'rendered_view'? classActiveButton : classInactiveButton} onClick={() => this.setState({view: 'rendered_view'})}>
                    <img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAzFBMVEX///8UHziA0fn0eHgMGjUAACHc3d83PU4AFzT4enm6X2SC1P1vtdoADC0GBSaIi5NjocMAABz09PXDxMj/fXwAEjIAAB+F2f8AACgAABkPFzEAACYJCykAABXo6et8yvF0eIN2wOapq7KHiZGQk5xXjq5BSFkwTmjT1NczOkwbJj56foiZnKQpMkcYIzw/ZoIkOVNoqs5fm70nP1hEbotMe5lHTl67vcIAGzZnbHdTWWilp64kLURTiKc5XXguS2R+RlJhOkqhVF0lJDsiWPYxAAAImUlEQVR4nO2da2OaPBTHtU1aNoQKjotCq/VW761dW1tn92zt9/9OD95IgKDcHAnN/900zfLzhJOcEziUSiTdLLqt/nRUZkWjab/VXdwQWQiqjVe6KQkg72HHEhAkC67GteN46gRAiS04JCDB8uQI4EQyWcXbCpjarwN8g6mV9wjTC1jDQRhgR2HbfnsBpUu+Al8KYMCdrCUJcKTlPa4MJU3VAOBMyHtUmUoLII6KBeggDr2AS8nfomHLMmRFsmw3/ADSGw545XMyDX1035tX2NG8dz/SfZAQW/wHiucrW36qiIbIlgyx8iR7GfULl3CFr4NAv28a4hl7Eo3mvY4TCv094ASfow0wN/Iea1KJxryBmxG2dwuFiQM+NFm0315i8wFDBLOdCU0cUGQZ0EE8wxGtrRE9CwXTFlxLbOJGnK4BF9hVqFdYB3QQ59jKoKzDjDe0H7WfmHUymIzfyIrSlUOIbdfkZt6jy0LireyZpgOI3EzAhOullNBF+McnGXJcGffIiPCm1Eae1HcVOivoY69X9S//ojjv9R4rPpqQxrlIrCCrWbXS2L0MwYMXsHIHZdvZf/++xT4XxXcAbduGo0fxaOO8JKI8qDQpLd0dW+MJH5zxruxs3dCr7ux1VtT9JId3Z+LhxrkJ8zXauLRCnrSH2+od87nX1f03zRma4vZP8XDj3CS+2+7EXJYwTzpHQxNvPeGGtXOyxm8b+1R+Ng41zk/io+tNwSVGCDFHY9x5AhF7O4HFimfvXla2Fx25cY4S52i9WIUQNuWyR2D7l0/eAGw3r8mNcxTuTMtkQrHqG/R2ITFW3oRq484Ib5yjohD2bO+g5Y37MPzG+mmEN85RSQiteQxCa84AYdWXmtrN0gffLP1thDfOUREIz5reQYPZ1pc+e6219zTExjkqCiEegaxRnreEtxD/dB+LkBvnqCiEvkXc3n1s3ONGhO/iocb5KQqhsy24Rt8o7jfiA0K078TDjXNTJMIzowp3MLaNuaCzu11quaHci0ca56ZohE4Y8dSAsqyXn8+85D91WZbhf560akjjnBSRcG2wSrXqD3WdCPF2Xp03Ax8TG+ejyISHshikfmnJYsQhZFSckH1xQvbFCdnXlyYsikII7V61KMLzKhhh2ZaLIjyKxQmLKU7Ivjgh++KE7OtrEYLiiEwIhpdF0RAQCWHkZ7+o101IbHFx/E8Z0QUnZF6ckH1xQvbFCdkXJ2RfnJB9cUL2RRnhzUUSHQxmKSJU20sz4dPN5nIR2i09hF3JSv6UvGBpYYVMaCG8EMzguGPJLJPHTAlhTU9faARAYs0dOghr18EBJ1CdVKolDuFNu3OVSt2QYjF4OiyNgEnwqjEIu3VTSidTeSE69n5WhTg0QqWW6IStLH5oDQQqqZRKi4xM6EgPXoqRCQfZXCpSK0g4zK6ckfCSnLCVUVEeGBxCPZueN7oOXAaRCS8z+qGDPf/CVsJXQYsv4RV1sKsrQBch9oi88Of8R3yd/0GeSupQOEv77m/3+vfHeRL9+OtaUQh4Uwo8DZodwvdviQi/fXeNCC4TE55utaCG8GQrPj2Ep9q1UUR4InFCTsgJOSEn5ISckBP+Y0I1pSgnVFuzupJGdXNJ2phSQzjIoD67cE2oPU0NYTb15+vBdB8thJO0Jye7EQz9HVND2M8oE6UHYmBaCLNK2x7K4uVL+JLR2QK9NszqOpz6O6aGsPi+tDTQi74eOnuacrH3NBvIYu9LTyVOyAk5ISfkhJyQE3LCf0oY4wx4Qd6gUU4Y5xzfgofey0cpYcx7MerHXq9IHWHs+2mC6QrKCWPfE2VGNSIthLHva9Pe/F1wQj5LT0xYfE9T/NXiC6z4X2DXdipxQk7ICTkhJ+SEnJATckJOyAk5ISfkhJyQE3JCTvjlCBdv6SpED18mpCQjNYRqH2ppS2ubFqEMEDWEl1I5vYBO6JgSwoyKyBBq5NBCuMzqXv3ApUgLYfGft8jqmRl6CTtZOBpnBJK/Y2oIb7Kp3kI4V6SFsNS+zmCeWoRyY9QQlmorxUonaBEeKKGI0GlcSydyyT2aCE8jTsgJOSEn5ISckBPihK8fCQk/3LqJoE8hIRZbf55/S6LzT7eHFJUhN40j78/ivNTsCsVlr58f3+Pr4xMVMJWuUhDWptF33vV+9EmwsND/W34V4gsr0FoOJvNOFT0J18Ty4UTpMfo9JkIR31NFwECITNjKJn2wFqE8amTCcdxhBCv6himrguXrcQcdwAmfRgj+nGHqWMe7iyRShE3B8xaO+tkUKZaC1bxPmREOVmUOlzrNAlEK1i+KQxg7q6+EvCaAjNhPP1EtkgXjrBb9eK7GijFJ1+ro6TyqBElZrliEsU7XtHpMQMejtnRLEhId2gmSBcdh26jTnJAOW9HXeyR10VkmOnpdXoW/SMdLOEOEcS4iujVAhLPSCl1FSWxAp2rIh62w8yUz8oaEerXdEl5O7PjmrnnaOO+BZSb04KTwhkVqhKJjrGrlTkypW1qgmmyEOwrY1AWKzawF/i+pKNMUi4nWT7XO0PbaivEEIcVS0VoBViXP48wFMSIWXW+Iatj6H2vnTKsGCgLSN0AATVNQZn+eqgLGM9p8hL+ZSAskV5nTEAtq91kVDQvlpUu2ragOsbgagN2nEzwSFQSWr8WBhqcloLsPneL5GKCMWTWj2lI8JOjEBvc+65lqdVjc3VyMLW/KQMEour6MiaRPx+3aINFrbPPQoNZurfwpEeipYbH0J0yAZloJX2ObhyxT82c+JV9OZZTVKyVpkeZPM6qzYiFq04C7VEcZvSiPCklDwnqgvmR1kpC/IOF2yLU6Skb3BOcsoIQkip11cVUAMwJ4eWg1n5gm23YElnAkZahONBhYWlgRkOAoSiWnWmukm5LAFubmHGM1jhw13Cy6b/3pKO9hR9Zo2m91F+Rzmv8Biw7t6uwB8DEAAAAASUVORK5CYII="
                        src4="https://img.pngio.com/computer-icons-black-png-download-512512-free-transparent-eye-symbol-png-900_520.jpg"
                        src3="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRfy_TUlwF-_1TK3CLRF_MlQwbAnI5tkHXTJu00VK8MJoOxAxBW&usqp=CAU"
                        src2="https://icons-for-free.com/iconfiles/png/512/browser-131988545399276981.png"
                        style={{height: '25px'}}
                        alt="rendered"/>
                  </label>
                  &nbsp;
                  <label className={this.state.view === 'both'? classActiveButton : classInactiveButton} onClick={() => this.setState({view: 'both'})}>
                    <img
                        src="/images/lesson-icons/html/code-file.png"
                        src4="https://image.flaticon.com/icons/png/512/51/51953.png"
                        src3="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTeNso4NRZVC1JNli6jHXF_KoP8v5xh-oTJLDXM552McJM-Pvkd&usqp=CAU"
                        src2="https://cdn0.iconfinder.com/data/icons/seo-smart-pack/128/grey_new_seo-37-512.png"
                        style={{height: '25px'}}
                        alt="code"/>
                    +
                    <img
                        src="data:image/png;base64,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"
                        src2="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTeNso4NRZVC1JNli6jHXF_KoP8v5xh-oTJLDXM552McJM-Pvkd&usqp=CAU"
                        style={{height: '25px'}}
                        alt="both"/>
                  </label>
                </div>
            </center>

            {questionComponent}
        </div>
    }
}



class CodeView extends Component {

    render(){

        const { t } = this.props;

        let paragraph = this.props.paragraph;
        /*console.log('BBBBBBBBBBBBB')
        console.log(this.props)*/

        let components = {
          'code': <ReadonlyCodeEditor
                language="html"
                value={paragraph.content}
                markers={paragraph.markers}/>,
          'code_input':  <CodeEditor
                        language="html"
                        raw={true}
                        value={this.props.data.chosenAnswers[0]? this.props.data.chosenAnswers[0]: paragraph.content }
                        onValueChange={(value)=>this.props.dispatch({'type':'SET_GENERIC', chosenAnswers: [value]})}
                   />,
          'double_code': <div className="row">
                <div className="col-lg-6">
                    {paragraph.content[0].fname}
                    <ReadonlyCodeEditor
                            language="html"
                            raw={true}
                            value={ paragraph.content[0].code }
                       />
                </div>
                <div className="col-lg-6">
                    {paragraph.content[1].fname}
                    <ReadonlyCodeEditor
                            language="html"
                            raw={true}
                            value={ paragraph.content[1].code }
                       />
                </div>
            </div>,
          'text':             <div className="question-question">
            <ReactMarkdown source={t(paragraph.content, paragraph.vars)} />
        </div>

        }

        var component = components[this.props.paragraph.type]


        return <div>
            <div className="row">
                <div className="col-lg-12">
                    {component}
                </div>
            </div>
        </div>
    }
}


class CodeRenderView extends Component {

    render(){
        //const { t } = this.props;

        let paragraph = this.props.paragraph;

        return <div>
            <div className="row">
                <div className="col-lg-12">
                    <FakeBrowser html={paragraph.content}/>
                </div>
            </div>
        </div>
    }
}


class BothView extends Component {

    render(){
        //const { t } = this.props;

        return <div>
            <div className="row">
                <div className="col-md-6">
                    <CodeView {...this.props}/>
                </div>
                <div className="col-md-6">
                    <CodeRenderView {...this.props}/>
                </div>
            </div>
        </div>
    }
}


function select (state) {
  return {
    data: state
  }
}

export default connect(select)(
    withTranslation()(
        RenderCodeEditor
    )
);
